import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.297 3.295a.998.998 0 0 1 1.415-.001c.39.39.384 1.03-.001 1.415l-7.3 7.3 7.294 7.27a.999.999 0 1 1-1.414 1.414l-7.29-7.265-7.29 7.266a.999.999 0 1 1-1.414-1.414l7.295-7.27-7.3-7.301a1.006 1.006 0 0 1-.002-1.415.998.998 0 0 1 1.415 0l7.296 7.297 7.296-7.296z"
});

var SvgX = function SvgX(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgX;